import { h } from 'preact'
import { PureComponent } from 'preact/compat'

import SearchContext from './SearchContext'

function buildContextForProps(context) {
    return {
        ...context.driver.getState(),
        ...context.driver.getActions(),
    }
}

/* For a given object execute mapContextToProps to pluck out the relevant
properties */
function giveMeJustWhatINeeded(stateOrContext, mapContextToProps, props) {
    const mapContextToPropsToUse = props.mapContextToProps || mapContextToProps
    return mapContextToPropsToUse(stateOrContext, props) || {}
}

export default function withSearch(mapContextToProps) {
    if (!mapContextToProps) {
        throw Error(
            'withSearch requires a function to be provided which returns an object with at least one value.',
        )
    }

    return Component => {
        class WithSearch extends PureComponent {
            constructor(props, context) {
                super()

                this.state = {
                    ...giveMeJustWhatINeeded(
                        buildContextForProps(context),

                        mapContextToProps,
                        props,
                    ),
                }

                context.driver.subscribeToStateChanges(this.subscription)
            }

            componentWillUnmount() {
                const { driver } = this.context

                this.unmounted = true
                driver?.unsubscribeToStateChanges(this.subscription)
            }

            subscription = state => {
                if (this.unmounted) return
                this.setState(prevState =>
                    giveMeJustWhatINeeded(
                        {
                            // We pass prevState here instead of just state so that actions are
                            // persisted as well, which are not passed in the subscription param
                            ...prevState,
                            ...state,
                        },
                        mapContextToProps,
                        this.props,
                    ),
                )
            }

            render() {
                const { ...rest } = this.props

                return <Component {...this.state} {...rest} />
            }
        }

        WithSearch.contextType = SearchContext
        return WithSearch
    }
}
